// extracted by mini-css-extract-plugin
export var base = "_2s-0";
export var updateBanner = "_2s-1";